import type { NumberedListComponent } from "../../types";

/** Ordered numbered list renderer. */
export function NumberedListRenderer({ component }: { component: NumberedListComponent }) {
  const { items } = component.content;
  if (!items?.length) return null;
  return (
    <section className="mt-4 md:mt-6">
      <ol className="list-decimal list-outside ml-5 md:ml-6 space-y-2 md:space-y-3 text-base xl:text-lg text-[#121212]">
        {items.map((text, i) => (
          <li key={i} className="pl-1">
            {text}
          </li>
        ))}
      </ol>
    </section>
  );
}
